/**
 * TenantSwitcher — admin header dropdown for super-admins (Phase 35.3).
 *
 * Lists all tenants; selecting one stores the choice in the Zustand store
 * and propagates it into every subsequent API call as X-Tenant-Id.
 * Non-super-admins never see this component.
 */
import { useEffect, useState } from "react";
import { useStore } from "../store/useStore.js";
import { listTenants } from "../services/adminTenants.js";

export default function TenantSwitcher() {
  const activeTenantId = useStore((s) => s.activeTenantId);
  const setActiveTenant = useStore((s) => s.setActiveTenant);
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listTenants()
      .then((data) => {
        setTenants(data.tenants || []);
        // If no tenant is selected yet, default to the first active one.
        if (!activeTenantId && (data.tenants || []).length > 0) {
          const first = data.tenants.find((t) => t.status === "active") || data.tenants[0];
          if (first) setActiveTenant(first.tenantId);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return null;
  if (tenants.length === 0) return null;

  return (
    <div className="tenant-switcher">
      <label className="tenant-switcher__label" htmlFor="tenant-select">
        Tenant
      </label>
      <select
        id="tenant-select"
        className="tenant-switcher__select"
        value={activeTenantId || ""}
        onChange={(e) => setActiveTenant(e.target.value || null)}
      >
        {tenants.map((t) => (
          <option key={t.tenantId} value={t.tenantId}>
            {t.name || t.tenantId}
            {t.status !== "active" ? ` (${t.status})` : ""}
          </option>
        ))}
      </select>
    </div>
  );
}
